// const constants = {
//   apiHost: 'https://localhost:3030/',
//   domain: 'coach.getboarded.com',
//   cookieScope: '.https://coach.getboarded.com',
//   url: 'https://www.coach.getboarded.com'
// };
//
// if (process.env.NODE_ENV === 'development') {
//   constants.apiHost =  'http://localhost:3030/';
//   constants.domain = 'localhost';
//   constants.cookieScope = 'localhost';
//   constants.url = 'http://localhost:8080';
// }
//
// export default constants;
const constants = {
  apiHost: 'https://api.coach.getboarded.com/',
  domain: 'coach.getboarded.com',
  cookieScope: '.https://coach.getboarded.com',
  url: 'https://coach.getboarded.com'
};

if (process.env.NODE_ENV === 'development') {
  constants.apiHost =  'http://localhost:3040';
  constants.domain = 'localhost';
  constants.cookieScope = 'localhost';
  constants.url = 'http://localhost:8080';
}

export default constants;
